module.exports = __webpack_public_path__ + "static/media/marker_prospect.d5a63076.svg";